/** Statuts pour lesquels le même acheteur ne peut pas repasser commande sur le même dossier (API + UI).
 *  D’autres acheteurs ne sont pas concernés — ils ont leurs propres lignes `transactions`. */
/** Checkout abandonné (`en_attente`) ne bloque pas la marketplace — seulement le séquestre validé et la suite. */
export const BLOCKING_PURCHASE_STATUSES = new Set([
  "paye",
  "appel_en_cours",
  "appel_effectue",
  "fonds_debloques",
  "litige",
]);

export function hasBlockingPurchaseForDossier(transactions, dossierId) {
  if (!dossierId) return false;
  return (transactions || []).some((t) => {
    const sameDossier = String(t.dossier_id ?? "").trim() === String(dossierId ?? "").trim();
    const st = String(t.statut ?? "")
      .trim()
      .toLowerCase();
    return sameDossier && BLOCKING_PURCHASE_STATUSES.has(st);
  });
}
